//引入Vue
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入App
import App from './App.vue'
//引入VueRouter
import VueRouter from 'vue-router'
//引入路由器
import router from './router'
// import axios from 'axios'
import axios from '@/util/request'
// import VueAxios from 'vue-axios'

import Cookies from "js-cookie";


Vue.prototype.$cookie = Cookies;
import { resetForm } from "@/util/xiaokang";
Vue.prototype.resetForm = resetForm
// 引入视频
// import VueVideoPlayer from 'vue-video-player'
// require videojs style
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
// Vue.use(VueVideoPlayer)
Vue.use(ElementUI, { size: 'medium', zIndex: 3000 });
// Vue.use(VueAxios, axios)
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}
Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}
//关闭Vue的生产提示
Vue.config.productionTip = false
//应用插件
Vue.use(VueRouter)


//创建vm
new Vue({
	el:'#app',
	render: h => h(App),
	router:router
})
